export const downloadMetaMaskLink = "https://metamask.io/download/";
